import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

export const TermsOfServicePage = () => {
  return (
    <LegalPageLayout title="Kullanım Şartları" enTitle="Terms of Use" updatedAt="16 Ekim 2026">
      <p className="legal-intro">
        Bu Kullanım Şartları, "Martinci İmza Yönetim Portalı" ticari adıyla faaliyet gösteren
        Utku Tamer Göktaş (Vergi Kimlik No: 4060564940, Göztepe Vergi Dairesi) tarafından
        sunulan Martinci İmza Yönetim Portalı'nı ("Hizmet") kullanımınızı düzenler. Hizmete kayıt
        olarak veya kullanarak bu şartları kabul etmiş sayılırsınız.
      </p>

      <h2>1. Hizmetin Tanımı</h2>
      <p>
        Martinci, organizasyonların e-posta imzalarını merkezi olarak yönetmesini sağlayan
        çok kiracılı (multi-tenant) bir SaaS platformudur. İmza şablonları, organizasyonunuzun
        bağladığı Microsoft 365 veya Google Workspace dizinindeki gruplara göre otomatik olarak
        eşleştirilir ve Outlook Add-in aracılığıyla gönderim anında uygulanır.
      </p>

      <h2>2. Hesap Oluşturma ve Sorumluluklar</h2>
      <ul>
        <li>Hizmete kaydolurken verdiğiniz bilgilerin doğru ve güncel olduğunu beyan edersiniz.</li>
        <li>Hesap kimlik bilgilerinizin (şifre dahil) gizliliğinden ve hesabınız üzerinden
          gerçekleştirilen tüm işlemlerden siz sorumlusunuz.</li>
        <li>Organizasyon yöneticisi (org_admin) sıfatıyla kayıt oluyorsanız, organizasyonunuz adına
          bu şartları kabul etme yetkisine sahip olduğunuzu beyan edersiniz.</li>
        <li>Organizasyonunuza eklediğiniz personelin kişisel verilerini (imza şablonlarında
          kullanılan ad, unvan, telefon gibi bilgiler) işlememiz için gerekli izinlere sahip
          olduğunuzdan siz sorumlusunuz.</li>
      </ul>

      <h2>3. Deneme, Planlar ve Ödeme</h2>
      <ul>
        <li>Yeni organizasyonlar 14 günlük ücretsiz deneme ile başlar; deneme süresi, organizasyonun
          ilk imzası bir e-postaya eklendiğinde işlemeye başlar.</li>
        <li>Ücretli plan "Pro"dur: kullanıcı başına aylık 2 ABD doları, yıllık ödemede %20 indirim;
          fiyatlara KDV dahil değildir. Tahsilat, ödeme anındaki T.C. Merkez Bankası döviz satış
          kuruyla Türk lirası olarak yapılır.</li>
        <li>Ödemeler PAYTR'nin güvenli ödeme altyapısı üzerinden alınır; kart bilgileriniz Martinci
          sunucularına hiçbir şekilde ulaşmaz. Abonelik, kapatılmadığı sürece dönem sonunda
          otomatik olarak yenilenir.</li>
        <li>Satın alma, yenileme, iptal ve iade koşulları{' '}
          <Link to="/mesafeli-satis-sozlesmesi">Mesafeli Satış Sözleşmesi</Link> ve{' '}
          <Link to="/on-bilgilendirme-formu">Ön Bilgilendirme Formu</Link>'nda düzenlenmiştir.</li>
        <li>Fiyatlar önceden haber verilerek güncellenebilir; mevcut faturalandırma döneminizi
          etkilemez.</li>
      </ul>

      <h2>4. Kabul Edilebilir Kullanım</h2>
      <p>Hizmeti kullanırken aşağıdakileri yapmamayı kabul edersiniz:</p>
      <ul>
        <li>Hizmeti yasa dışı, yanıltıcı veya başkalarının haklarını ihlal edecek şekilde kullanmak,</li>
        <li>Hizmetin güvenliğini aşmaya veya yetkisiz erişim sağlamaya çalışmak,</li>
        <li>Başka bir organizasyonun verilerine izinsiz erişmeye çalışmak,</li>
        <li>Hizmeti aşırı yük bindirecek veya işleyişini bozacak şekilde kullanmak.</li>
      </ul>

      <h2>5. Veri Sahipliği ve Gizlilik</h2>
      <p>
        Organizasyonunuzun sisteme yüklediği veriler (imza şablonları, personel bilgileri) size
        aittir. Bu verileri nasıl işlediğimiz hakkında bilgi için{' '}
        <a href="/gizlilik-politikasi">Gizlilik Politikası</a>'nı ve{' '}
        <a href="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</a>'ni inceleyebilirsiniz.
      </p>

      <h2>6. Hizmetin Kullanılabilirliği</h2>
      <p>
        Hizmeti kesintisiz ve hatasız sunmak için makul çabayı gösteririz, ancak bakım, üçüncü
        taraf servis kesintileri (Microsoft, Google, PAYTR) veya öngörülemeyen teknik sorunlar
        nedeniyle geçici kesintiler yaşanabilir.
      </p>

      <h2>7. Fesih</h2>
      <p>
        Hesabınızı istediğiniz zaman kapatmamızı talep edebilirsiniz. Bu Kullanım Şartları'nın
        ihlali hâlinde, önceden makul bir bildirimde bulunarak hesabınızı askıya alma veya
        sonlandırma hakkını saklı tutarız.
      </p>

      <h2>8. Sorumluluğun Sınırlandırılması</h2>
      <p>
        Hizmet "olduğu gibi" sunulur. Yürürlükteki mevzuatın izin verdiği azami ölçüde, hizmetin
        kullanımından doğan dolaylı zararlardan sorumlu tutulamayız.
      </p>

      <h2>9. Şartlardaki Değişiklikler</h2>
      <p>
        Bu şartları zaman zaman güncelleyebiliriz. Önemli değişikliklerde sizi bilgilendireceğiz;
        hizmeti kullanmaya devam etmeniz güncellenmiş şartları kabul ettiğiniz anlamına gelir.
      </p>

      <h2>10. İletişim</h2>
      <p>
        Bu şartlarla ilgili sorularınız için <a href="mailto:destek@martinci.com">destek@martinci.com</a>{' '}
        adresinden bize ulaşabilirsiniz.
      </p>
    </LegalPageLayout>
  );
};

export default TermsOfServicePage;
